angular.module('tgaAdmin')
  .controller('HubGamePlayerListsModalController', [
    '$scope', '$state', '$window', '$uibModalInstance', '$uibModalStack', 'playerListService', 'extras',
    function (
      $scope, $state, $window, $uibModalInstance, $uibModalStack, playerListService, extras,
    ) {
      $scope.data = {
        alerts: [],
        closeButton: extras.closeButton,
        playerLists: [],
      };

      $scope.viewmodel = {
        game: angular.copy(extras.game),
      };

      $scope.initialize = function () {
        playerListService.getPlayerLists().then((playerLists) => {
          $scope.data.playerLists = [];
          playerLists.forEach((playerList) => {
            $scope.data.playerLists.push({
              player_list_id: playerList.player_list_id,
              name: playerList.name,
            });
          });
        });
      };

      $scope.actions = {
        submit(form) {
          form.submitted = true;

          $scope.actions.clearAlerts();

          if (form.$invalid) {
            return;
          }

          $uibModalInstance.close($scope.viewmodel.game);
        },
        createAlert(msg, type) {
          $scope.actions.clearAlerts();
          $scope.data.alerts.push({
            msg,
            type,
          });
        },
        clearAlerts() {
          $scope.data.alerts = [];
        },
        close() {
          $uibModalInstance.dismiss();
        },
      };
      $scope.initialize();
    },
  ]);
